/** @format */

import { ReactComponent as BagIcon } from "images/svg/bag.svg";
import Educat from "images/empty.png";

const EmptyNotice = ({ text, type }) => {
  return (
    <section className="d-flex flex-column">
      {type === "webinar" ? (
        <div className="d-flex justify-content-center">
          <figure className="error-image">
            <img
              src={Educat}
              alt="Empty Notice"
              className="empty-notice-image"
            />
          </figure>
        </div>
      ) : (
        <div className="d-flex justify-content-center">
          <BagIcon />
        </div>
      )}

      <div className="d-flex justify-content-center">
        <p className="error-text">{text}</p>
      </div>
    </section>
  );
};

export default EmptyNotice;
